const CircularImages = ({ images }) => {
  return (
    <div className='min-w-full md:min-w-[500px] flex items-center justify-center'>
      <div className="relative gap-4 p-10">
      <div className="rounded-full relative w-40 md:w-52 h-52 z-10">
        <img
          src={images[2].url}
          alt="Image1"
          className="rounded-full object-cover border-4 border-white"
        />
      </div>
      <div className="rounded-full absolute w-32 md:w-40 h-40 left-[-20%] top-[30%] z-0">
        <img
          src={images[0].url}
          alt="Image2"
          className="rounded-full object-cover border-4 border-white"
        />
      </div>
      <div className="rounded-full absolute w-32 md:w-40 h-40 right-[-20%] top-[30%] z-0">
        <img
          src={images[1].url}
          alt="Image3"
          className="rounded-full object-cover border-4 border-white"
        />
      </div>
    </div>
    </div>
  );
};

export default CircularImages;